// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"201":"e563a89a","301":"494d4155","529":"928beb4b","798":"cccc4324","967":"7bb02684"}[chunkId] + ".css";
};